import React, { Component } from 'react';
import {Table} from "antd";
import moment from "moment-timezone";
import { connect } from "react-redux";
import { deleteDocument } from "../redux/actions/Firebase";

import { bindActionCreators } from "redux";

class StationsList extends Component{
  state = {
    columns: [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        align: 'center',
      },
      {
        title: 'Empresa',
        dataIndex: 'empresa',
        key: 'empresa',
        align: 'center',
      },
      {
        title: 'Credencial',
        dataIndex: 'token',
        key: 'token',
        align: 'center',
      },
      {
        title: 'Fecha de caducidad',
        dataIndex: 'fechaCaducidad',
        key: 'fechaCaducidad',
        render: item => (
            <p>{moment(item).tz("America/Monterrey").format("YYYY/MM/DD HH:mm:ss").toString()}</p>
          ),
        align: 'center',
      },
    ]
  }

  handleDelete = (name) => {
    this.props.deleteDocument(name);
  }

  render(){
    return(
        <div style={{paddingTop: 50}}>
            <Table
              dataSource={this.props.credentials}
              columns={this.state.columns}
              pagination={{
                style: { flex: 1, width: '100%', marginTop: 25, textAlign: 'center' }
              }}
            />
        </div>
    )
  }
}

const mapStateToProps = state => {
  return { credentials: state.tokens.data,
          firebase: state.firebase
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({deleteDocument}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StationsList)